import React, { FC } from 'react';

import { EvToast } from '@evinced-private/ui-common';

import { PropertyImportUrlsButton } from '../../../components/property-settings/property-import-urls-button/PropertyImportUrlsButton';

import { SEEDS_LABELS } from './SeedsSettingsV2.labels';
import { SeedsTableActionsProps } from './SeedsSettingsV2.types';

export const SeedsTableActions: FC<SeedsTableActionsProps> = ({
	isListMode,
	isImportInProgress,
	showImportToast,
	importAnnouncement,
	toastStatus,
	onToastClose,
	onImport
}) => {
	return (
		<div className="table-actions-header">
			{showImportToast && (
				<EvToast
					announcement={importAnnouncement}
					status={toastStatus}
					show={showImportToast}
					onToastClose={onToastClose}
				/>
			)}
			{isListMode && (
				<PropertyImportUrlsButton
					importing={isImportInProgress}
					validHeader={SEEDS_LABELS.IMPORT_VALID_HEADER}
					onConfirm={onImport}
				/>
			)}
		</div>
	);
};
